export default __webpack_public_path__ + "static/media/electronics.bfff0209.png";